export const GERMAN = 'de';
export const ENGLISH_UK = 'en-GB';
export const ENGLISH_US = 'en-US';
export const FRENCH_FRANCE = 'fr-FR';

export const knownLocales = [GERMAN, ENGLISH_UK, ENGLISH_US, FRENCH_FRANCE];
